<template>
	<div class="merchantstatistics">
		<div class="top">
			<el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>           
             <span>监管账户余额：{{balance||"0"}}</span>
             <el-input class="search-input" style="width:20%;float: right;"  placeholder="商户名称/编码" icon="search" size="medium" @change="queryAbcagentList()"
                          v-model.trim="pagination.searchVal">
                    <el-button slot="append" icon="el-icon-search" @click="queryAbcagentList()"></el-button>
            </el-input> 
            <el-autocomplete  style="width:20%;float: right;" class="inline-input" v-model="pagination.schoolName"   size="medium" :fetch-suggestions="querySearch" placeholder="请输入学校名称"  :trigger-on-focus="false"  @select="handleSelecttwo" ></el-autocomplete>
        </div>
		<div>
			<el-table :height="windowHeight - 210" :data="dataList" style="width: 100%" border>	
				<el-table-column label="二级商户名称" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.subMerName }}
					</template>
				</el-table-column>
				<el-table-column label="二级商户编码" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.subMerId }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="收款账号" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.account }}
						</span>
					</template>
				</el-table-column>
                <el-table-column label="行号" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.recBankNo }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="学校" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.schoolName }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="收费总金额(元)" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.revenuetotal }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="已清分金额(元)" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.withdtotal }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="待清分金额(元)" align="center" show-overflow-tooltip prop="otherName">
					<template slot-scope="scope">
						<span>
							{{ scope.row.balance }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<!-- <el-button type="text" size="small" @click="deleteAbcagent(scope.row.id)">删除</el-button> -->
						<el-button type="text" size="small"  @click="merchantstatisticslist(scope.row.subMerId,scope.row.schoolId)">收支明细</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-container">
				<el-pagination @size-change="sizeChangeHandler" @current-change="currentChangeHandler" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size.sync="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :page-count="pagination.pages" :total="pagination.total"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>

import windowResize from '@/mixins/windowResize'
import baseMixin from '@/mixins/baseMixin'
import {querySchoolListByName,queryMerhPurseByMerhId,querySubmerhListByMerId} from '@/api/platformmerchant'

export default {
	name: 'subjectList',
	data() {
		return {
			pagination: {
				pageNo: 1,
				pageSize: 10,
				total: 0,
                merId:this.$route.query.merId,
                searchVal:"",
                schoolName:"",
                schoolId:0
			},
			dataList: [],
            balance:0
		}
	},
	created() {
          queryMerhPurseByMerhId(this.$route.query.merId)
        .then(res => {
          if (res.data.code === 200) {
           this.balance=res.data.data.balance;
           this.queryAbcagentList()
          }
        }).catch();
		
	},
	mixins: [windowResize, baseMixin],
	methods: {	
        
        handleSelecttwo(item) {
            this.pagination.schoolId=item.id;
            this.pagination.schoolName=item.value;
            this.queryAbcagentList()
      },
         querySearch(queryString, cb) {
      querySchoolListByName(queryString).then(res => res.data).then(data => {
                            if(data.result) {
                              let results=[{id:0,value:"全部"}]
                              let mydata=data.data;
                              for(let i=0;i<mydata.length;i++){
                                results.push({
                                  value:mydata[i].name,
                                  id:mydata[i].id
                                })
                              }
                              cb(results);
                            
                           }
        })        
      },
		merchantstatisticslist(subMerId,schoolId){
           this.$router.push({path:'merchantstatisticslist',query:{
			   subMerId:subMerId,
               schoolId:schoolId
		   }});
        },
		sizeChangeHandler() {
			this.queryAbcagentList()
		},
		currentChangeHandler() {
			this.queryAbcagentList()
		},
		queryAbcagentList() {
            if(!this.pagination.schoolName){
                this.pagination.schoolId=0
            }
		 querySubmerhListByMerId(this.pagination)
        .then(res => res.data)
        .then(data => {
          this.pagination.total = data.data.pagination.total;
          this.dataList = data.data.dataList;
        });
		}
	}
}
</script>
<style lang="scss" scoped>
.merchantstatistics {
	padding: 12px;
	.pagination-container {
		margin-top: 10px;
	}
	.top {
		padding-bottom: 10px;
		overflow: hidden;
	}
	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}
	.state-container {
		margin: 15px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/platformmerchant/merchantstatistics.vue